export default function gaBuyEvent(e, productKey, quantity) {
    $.ajax({
        type: 'GET',
        url: `/umbraco/api/products/getproduct?key=${productKey}&quantity=${quantity}`,
        dataType: 'json',
        success: async function (product) {
            if (window.location.pathname.includes("checkout") || window.location.pathname.includes("basket")) {
                window.location.reload();
            }
        }
    });
}
